import type { ReportButtonLabels } from '../../report-button-content';

export const reportButton: ReportButtonLabels = {
  report: 'இந்தப் பக்கத்தைப் புகாரளி',
  title: 'இந்தப் பக்கத்தில் உள்ள சிக்கலைப் புகாரளியுங்கள்',
  reasons: {
    'inaccurate-or-fabricated': 'தவறான அல்லது புனையப்பட்ட தகவல்',
    'wrong-product': 'தயாரிப்புகள் பக்கத்துடன் பொருந்தவில்லை',
    'sexually-explicit': 'வெளிப்படையான பாலியல் உள்ளடக்கம்',
    'regulated-product': 'மருந்துச்சீட்டு தேவைப்படும் அல்லது ஒழுங்குமுறைக்கு உட்பட்ட தயாரிப்பு',
    'dangerous-product': 'ஆபத்தான தயாரிப்பு',
    'ip-infringement': 'என் உரிமைகளை மீறுகிறது (வர்த்தகமுத்திரை/பதிப்புரிமை)',
    other: 'வேறு ஏதாவது',
  },
  detail: 'விவரங்கள் (விருப்பத்தேர்வு)',
  submit: 'புகாரை அனுப்பு',
  cancel: 'ரத்து செய்',
  sent: 'நன்றி. புகார்களை 24 மணிநேரத்துக்குள் பரிசீலிக்கிறோம்.',
  failed: 'புகாரை அனுப்ப முடியவில்லை. மீண்டும் முயற்சிக்கவும்.',
};
